const admiral = '#3625a8';
const aqua = '#a8d9dc';
const aquaTint = '#d4ecee';
const azure = '#246eff';
const azureTint = '#a7c5ff';
const black = '#000';
const brightSun = '#fad536';
const brightSunTint = '#fdea9b';
const cinnebar = '#e34e3d';
const cinnebarTint = '#f1a79e';
const emerald = '#5bd39c';
const emeraldTint = '#bdedd7';
const darkGray = '#5f5f5f';
const mediumGray = '#949fa8';
const lightGray = '#d8d8d8';
const backgroundGray = '#cfd8dc';
const ultraDarkGray = '#343434';
const ultraLightGray = '#f5f5f5';
const ultraLighterGray = '#f9f9f9';
const white = '#fff';

export default {
    // 2021 My ICSC redesign by color
    admiral,
    aqua,
    aquaTint,
    azure,
    azureTint,
    black,
    brightSun,
    brightSunTint,
    cinnebar,
    cinnebarTint,
    backgroundGray,
    darkGray,
    emerald,
    emeraldTint,
    mediumGray,
    lightGray,
    ultraDarkGray,
    ultraLightGray,
    ultraLighterGray,
    white,

    // 2021 My ICSC redesign by context
    background: darkGray,
    disabled: ultraLightGray,
    error: cinnebar,
    link: azure,
    primary: azure,
    primaryDark: admiral,
    secondary: black,
    success: emerald,
    warning: brightSun,
};
